import { firePixel } from "../pixels";
import { urlParam } from "../config";

//Fires the viewContent pixel when the visitor actually reaches what is being
//sold - what the ad networks optimise on as product interest, as opposed to
//pageView, which only says the page loaded.
//
//The landing marks the packages with data-sdk-view="product". It is deliberately
//an element and not a page: on some funnels the product is the whole page, on
//others it is a section far below an advertorial, and the same attribute covers
//both - marked on <body> the element is on screen from the start and this fires
//at once, marked on a section it fires when the section scrolls into view.
//
//Any part of it entering the viewport is enough; the pixel is meant to be the
//visitor reaching the offer, not a measure of how long they read it.
//
//Without a transaction there is nothing to report: someone reached the page
//directly. Reloads are safe - the CRM dedupes a pixel per transaction and type.
const SELECTOR = '[data-sdk-view="product"]';

export function viewContentPixel() {
	if (!urlParam("transaction_id")) {
		return;
	}

	//Nothing to watch with: report the block if the page already carries it,
	//rather than lose the event.
	if (typeof window.IntersectionObserver !== "function") {
		if (document.querySelector(SELECTOR)) {
			firePixel("viewContent");
		}
		return;
	}

	let fired = false;
	let watcher = null;

	//A landing may mark more than one block; the first one seen is the event.
	const observer = new IntersectionObserver((entries) => {
		if (fired || !entries.some((entry) => entry.isIntersecting)) {
			return;
		}

		fired = true;
		observer.disconnect();
		if (watcher) {
			watcher.disconnect();
		}
		firePixel("viewContent");
	});

	//Observing the same element twice is a no-op, so re-scanning costs nothing.
	const watch = () => {
		document.querySelectorAll(SELECTOR).forEach((target) => observer.observe(target));
	};

	watch();

	if (typeof window.MutationObserver !== "function") {
		return;
	}

	//The block is not always in the page when this runs. A quiz reveals its
	//offer only once the questions are answered, and a framework may replace
	//the node on a later render, so keep looking until the pixel has gone -
	//a marked block that appears at minute two is still the visitor reaching
	//the product.
	watcher = new MutationObserver(watch);
	watcher.observe(document.body, { childList: true, subtree: true });
}
